const removeCategoriasFromArticulosSelected = ({
  categorias = [],
  articulosSelected,
}: $TSMigrationFixMe) => {
  const newArticulosSelected = { ...articulosSelected }

  // @ts-expect-error TS(7006): Parameter 'categoria' implicitly has an 'any' type...
  categorias.forEach((categoria) => {
    delete newArticulosSelected[categoria.nombre]
  })

  return newArticulosSelected
}

export default removeCategoriasFromArticulosSelected
